// extracted by mini-css-extract-plugin
module.exports = {"container":"AccordionContent_container__3wMBK","title":"AccordionContent_title__2jV1V","subtitle":"AccordionContent_subtitle__13F1s","content":"AccordionContent_content__3Swp4"};